import { render, staticRenderFns } from "./GestionEvaluacion.vue?vue&type=template&id=67c1d5d5"
import script from "./GestionEvaluacion.vue?vue&type=script&lang=js"
export * from "./GestionEvaluacion.vue?vue&type=script&lang=js"
import style0 from "./GestionEvaluacion.vue?vue&type=style&index=0&id=67c1d5d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports